module.exports = __webpack_public_path__ + "static/assets/d16a2c96bd97f214cc889b5bc3f921b4.svg";